<s1-input-label [label]="label" class="bootstrap-theme">
  <ng-select class="form-control s1"
    [formControl]="control"
    [items]="itemsList"
    [readonly]="readonly"
    [ngClass]="{'is-invalid' : !checkIsValid() }"
    [bindValue]="'code'">
  </ng-select>
</s1-input-label>
